export default function Marquee({ items, slow = false, className = "", itemClassName = "" }) {
    const row = [...items, ...items];
    return (
        <div className={`marquee-hover overflow-hidden whitespace-nowrap ${className}`} data-testid="marquee">
            <div className={`inline-flex w-max items-center ${slow ? "animate-marquee-slow" : "animate-marquee"}`}>
                {row.map((item, i) => (
                    <span key={i} className={`inline-flex items-center ${itemClassName}`}>
                        {item}
                    </span>
                ))}
            </div>
        </div>
    );
}
